import { Component, Input, OnInit, signal } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { FormGroup } from '@angular/forms'
import { GrowthToolkitClient } from 'src/app/shared/services/ppv.api'
import { ApexNonAxisChartSeries, ApexChart, ApexPlotOptions } from 'ng-apexcharts'
import { ApexAxisChartSeries, ApexXAxis, ApexYAxis, ApexFill, ApexStroke, ApexLegend, ApexDataLabels, ApexTooltip, ApexOptions } from 'ng-apexcharts'

export type ChartOptions = {
   series: ApexAxisChartSeries
   chart: ApexChart
   fill: ApexFill
   stroke: ApexStroke
   dataLabels: ApexDataLabels
   xaxis: ApexXAxis
   yaxis: ApexYAxis
   grid: ApexGrid
   tooltip: ApexTooltip
   markers: ApexMarkers
}

@Component({
   selector: 'vc-kpi-card',
   templateUrl: './kpi-card.component.html',
   styleUrls: ['./kpi-card.component.scss'],
   standalone: false,
})
export class KPICardComponent {
   @Input() practiceSKey: any
   @Input() kpiName: any
   @Input() currentValue: any
   @Input() vetcorAvg: any
   @Input() goal: any
   @Input() showChart: boolean

   public chartOptions: Partial<ChartOptions>
   public Math = Math

   constructor(private growthToolkitClient: GrowthToolkitClient, private route: ActivatedRoute) {}

   getPercentageChange(cGoal: number, cValue: number): string {
      if (cGoal === 0) return 'N/A'
      const change = ((cValue - cGoal) / cGoal) * 100
      return `${change.toFixed(0)}%`
   }
}
